<div
  class="lum-modal custom-field-popup-form__modal-wrapper"
  *ngIf="isDialog; else customFieldForm"
>
  <div class="lum-modal__header justify-space-between w-p100">
    <span class="lum-modal__header-title flex text-large">Custom Fields</span>
    <div class="lum-modal__header-close">
      <button
        type="button"
        class="lum-button lum-button--secondary"
        mat-button
        (click)="dialogRef.close()"
      >
        <lum-ui-icon
          class="mr-2-5"
          icon="close-circle"
          color="#5563D6"
          width="23"
          height="23"
        ></lum-ui-icon>
        Close
      </button>
    </div>
  </div>
  <div class="lum-modal__body">
    <ng-container *ngTemplateOutlet="customFieldForm"></ng-container>
  </div>
  <div class="lum-modal__footer">
    <div class="flex ml-auto lum-modal__action gap-2">
      <button
        class="lum-button lum-button--large"
        [disabled]="submitting$ | async"
        (click)="onSubmit()"
      >
        <span class="d-flex align-items-center">
          Submit
          <mat-spinner
            class="inline-block ml-1"
            [diameter]="16"
            *ngIf="(submitting$ | async) || false"
          ></mat-spinner>
        </span>
      </button>
    </div>
  </div>
</div>

<ng-template #customFieldForm>
  <div
    class="custom-field-form-group__wrapper"
    *ngIf="(loading$ | async) === false; else loader"
  >
    <table
      class="lum-table lum-table--classic striped"
      *ngIf="customFields.length; else noRecords"
    >
      <thead class="table__head-row">
        <tr>
          <th>Label</th>
          <th>Value</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let customField of customFields; trackBy: trackById">
          <td>{{ customField?.label }}</td>
          <td [ngSwitch]="customField?.type">
            <input
              *ngSwitchCase="customFieldType.STRING"
              type="text"
              class="lum-input"
              [(ngModel)]="customField.value"
              (input)="emitValueChange()"
            />
            <input
              lumDecimalLimit
              *ngSwitchCase="customFieldType.NUMBER"
              type="number"
              class="lum-input"
              [decimalPlaces]="2"
              [invalidKeys]="['+']"
              [(ngModel)]="customField.value"
              (input)="emitValueChange()"
            />
            <input
              *ngSwitchCase="customFieldType.DATE"
              type="date"
              class="lum-input"
              [(ngModel)]="customField.value"
              (input)="emitValueChange()"
            />
            <mat-select
              *ngSwitchCase="customFieldType.DROPDOWN"
              class="lum-select"
              [(ngModel)]="customField.value"
              (selectionChange)="emitValueChange()"
            >
              <mat-option [value]="''"> --None-- </mat-option>
              <mat-option
                *ngFor="let option of customField?.options"
                [value]="option"
              >
                {{ option }}
              </mat-option>
            </mat-select>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-template>

<ng-template #loader>
  <div class="w-100">
    <mat-spinner diameter="20" class="mx-auto"></mat-spinner>
  </div>
</ng-template>

<ng-template #noRecords>
  <div class="text-center p-4">
    <h3>No records available.</h3>
  </div>
</ng-template>
